const axios = require('axios')

export const httpClient = axios.create({
  timeout: 7000
})
